module.exports = __webpack_public_path__ + "static/img/23.0d69bc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/23.png
// module id = vaVe
// module chunks = 0